<script lang="ts">
  import type { ImageAsset } from '$lib/types/contentTypes';
  import { CARD_VARIANT } from '$lib/constants/constants';
  import ArticleStandardCard from './ArticleStandardCard.svelte';
  import ProgramCard from './ProgramCard.svelte';
  export let title: string;
  export let description: string;
  export let subHeading: string;
  export let image: ImageAsset;
  export let mobileImage: ImageAsset;
  export let link: string;
  export let programDuration: string;
  export let showNewProgramCallout: boolean;
  export let showChallengeCallout: boolean;
  export let horizontalSmallDevice: boolean = false;
  export let variant: string = CARD_VARIANT.STANDARD;

  $: basicCard = {
    title,
    description,
    image,
    link,
    horizontalSmallDevice,
  };

  $: standardCard = {
    subHeading,
  };

  $: programCard = {
    programDuration,
    showNewProgramCallout,
    showChallengeCallout,
    mobileImage,
  };

  $: cardProps = {
    ...basicCard,
    ...(variant === CARD_VARIANT.PROGRAM ? programCard : standardCard),
  };

  $: cardComponent = variant === CARD_VARIANT.PROGRAM ? ProgramCard : ArticleStandardCard;
</script>

<svelte:component this={cardComponent} {...cardProps} />
